import { useState } from 'react';
import { Button } from '@eventbrite/marmalade';
import { FormattedMessage } from 'react-intl';
import { MAX_SLOTS_SHOWN_BY_DEFAULT } from '../Content/Content';
import styles from './ShowAllButton.module.scss';
import { Slot } from '../Content/Slots/Slot';

interface Props {
  slots?: Slot[];
  onChange: (showAllSlots: boolean) => void;
}

export const ShowAllButton: React.FC<Props> = ({ slots, onChange }) => {
  const [showAllSlots, setShowAllSlots] = useState(false);

  if (!slots?.length || slots.length <= MAX_SLOTS_SHOWN_BY_DEFAULT) {
    return null;
  }

  const toggleShowAllSlots = () => {
    const newValue = !showAllSlots;
    setShowAllSlots(newValue);
    onChange(newValue);
  };

  return (
    <Button variant="ghost" onClick={toggleShowAllSlots} className={styles.showAllAgendaButton}>
      {showAllSlots ? <FormattedMessage id="Show less" /> : <FormattedMessage id="Show all agenda" />}
    </Button>
  );
};
